import React from "react";
import { LoadingState } from "@/components/common/LoadingState";

/** What a models page shows until its first list lands: a loader, or — with
 *  no connection to land it — the offline notice. */
export const ModelsLoading: React.FC<{ isOnline: boolean; label: string }> = ({
  isOnline,
  label,
}) => (
  <div className="flex items-center justify-center w-full h-full">
    {isOnline ? (
      <LoadingState size="large" isLoading label={label} />
    ) : (
      <div className="offline-empty-state" role="status" aria-live="polite">
        <div className="empty-dot" />
        <div className="empty-text">You&apos;re offline</div>
        <div className="empty-sub">
          Your models will appear when the connection restores
        </div>
      </div>
    )}
  </div>
);
